// extracted by mini-css-extract-plugin
export default {"selectedNameAutoComplete":"styles_selectedNameAutoComplete__H7vvo","displayAlign":"styles_displayAlign__yNbfR","input":"styles_input__juGCB"};